import styled from 'styled-components';

// TODO: convert this to use typography
const StyledFormTitle = styled.span`
    // TODO: styleName: h1; 👈 - this is likely not an h1
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0.25px;
    text-align: left;

    margin-bottom: 20px;
`;

export default StyledFormTitle;
